import { Component, Input } from '@angular/core';
import { HyperlinkDto } from '@hub/generated/models';
import {OverlayPanel} from 'primeng/overlaypanel';
import {TooltipModule} from 'primeng/tooltip';

@Component({
	selector: 'g-columnHyperlinkList',
  templateUrl: './columnHyperlinkList.component.html',
  styleUrls: ['./columnHyperlinkList.component.scss']
})
export class ColumnHyperlinkListComponent {
  // Constants
  private DEFAULT_COUNT: number = 3;

  // Constructors
	constructor() { }

  // Input Properties
	@Input() data: HyperlinkDto[];
  @Input() delimiter: string;
  @Input() count: number;

  // Public Methods
  public getCount(): number
  {
    return this.count > 0 ? this.count : this.DEFAULT_COUNT;
  }
}
